import { CustomIconProps } from './art';

export const SmallSunWithCloudsIcon = ({
  width,
  height,
}: CustomIconProps): JSX.Element => (
  <svg
    width={width ? width : '413'}
    height={height ? height : '183'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <ellipse cx="211.5" cy="121" rx="71.5" ry="61" fill="#FDDA05" />
        <path
          d="M222.879 44.682a2 2 0 0 0-3.949.636l3.949-.636Zm-1.975.318c-1.974.318-1.974.317-1.974.316l-.001-.001v-.003l-.001-.005-.001-.006v.002l.007.057a5.887 5.887 0 0 1-.057 1.411c-.148.903-.536 1.96-1.478 2.825l2.707 2.945c1.784-1.64 2.472-3.618 2.718-5.123a9.773 9.773 0 0 0 .089-2.462 5.418 5.418 0 0 0-.02-.178l-.008-.059-.004-.021-.001-.009-.001-.004v-.001c0-.001 0-.002-1.975.316Zm-3.505 4.596c-.753.692-1.522.8-2.971.77-1.344-.028-3.528-.232-5.667.885l1.853 3.546c1.031-.54 2.017-.468 3.732-.432 1.608.033 3.786-.01 5.76-1.824l-2.707-2.945Zm-8.638 1.655c-2.142 1.12-3.496 3.088-4.122 5.076-.616 1.954-.617 4.213.328 6.018l3.544-1.855c-.33-.63-.442-1.74-.057-2.96.373-1.186 1.132-2.196 2.16-2.733l-1.853-3.546Zm-3.794 11.094c.874 1.67 1.925 2.376 2.709 2.904.633.427 1 .676 1.401 1.442l3.544-1.855c-.874-1.67-1.925-2.376-2.71-2.904-.633-.427-.999-.676-1.4-1.442l-3.544 1.855ZM207.937 36.684a2.001 2.001 0 0 0-3.744 1.409l3.744-1.41Zm-1.872.704-1.872.704-.001-.001v-.002l-.001-.002.001.002a.355.355 0 0 0 .009.027l.046.135a11.767 11.767 0 0 1 .504 2.471c.14 1.574-.095 3.04-.973 4l2.953 2.7c2.011-2.2 2.181-5.077 2.004-7.055a15.71 15.71 0 0 0-.761-3.58 5.926 5.926 0 0 1-.024-.068c-.004-.008-.006-.016-.008-.022a.108.108 0 0 0-.003-.007l-.001-.003-.001-.002-1.872.703Zm-2.287 7.335c-.371.405-.832.645-1.534.818-.852.21-1.553.235-2.822.437-1.122.18-2.449.482-3.738 1.264-1.317.799-2.458 2.012-3.37 3.797l3.562 1.82c.615-1.205 1.273-1.827 1.882-2.197.638-.387 1.369-.586 2.294-.734.778-.124 2.113-.249 3.147-.503 1.184-.291 2.458-.829 3.532-2.004l-2.953-2.698Zm-11.464 6.316c-2.095 4.101-.081 8.11 2.137 10.896 2.283 2.868 5.343 5.188 6.853 6.326l2.407-3.194c-1.529-1.152-4.202-3.2-6.13-5.622-1.992-2.504-2.665-4.707-1.705-6.586l-3.562-1.82Zm8.99 17.222c1.867 1.408 3.323 1.725 4.531 1.988 1.025.222 1.801.389 2.972 1.272l2.408-3.194c-1.868-1.408-3.324-1.725-4.532-1.987-1.024-.223-1.8-.39-2.972-1.273l-2.407 3.194Z"
          fill="#FDDA05"
        />
        <g filter="url(#c)">
          <ellipse
            cx="176"
            cy="112"
            rx="7"
            ry="5"
            fill="#FB9378"
            fillOpacity=".38"
          />
        </g>
        <g filter="url(#d)">
          <ellipse
            rx="6.693"
            ry="5.382"
            transform="matrix(.95335 -.30185 .4334 .9012 229.286 106.871)"
            fill="#FB9378"
            fillOpacity=".38"
          />
        </g>
        <path
          d="M212.84 109.154s-1.418 3.39-9.155 3.858c-7.738.467-8.899-2.767-8.899-2.767"
          stroke="#CFB202"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="188.5" cy="106.5" r="1.5" fill="#666" />
        <circle cx="217.5" cy="104.5" r="1.5" fill="#666" />
      </g>
      <g filter="url(#e)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M388.637 28.909c8.096.03 14.644 4.498 14.636 9.997-.009 5.51-6.596 9.966-14.713 9.954a21.518 21.518 0 0 1-3.087-.225c-.869 4.442-5.751 7.861-11.662 7.893-3.985.022-7.519-1.501-9.679-3.854-3.732 4.054-10.054 6.739-17.239 6.778-8.672.047-16.129-3.773-19.309-9.25-2.082 1.587-4.733 2.536-7.619 2.532-5.563-.008-10.244-3.554-11.653-8.378-3.47-.383-6.193-2.895-6.308-6.037-.128-3.507 3.042-6.47 7.081-6.617a8.178 8.178 0 0 1 3.454.614c2.057-1.515 4.647-2.416 7.459-2.412.435.001.865.023 1.288.066 2.035-3.614 6.07-6.072 10.712-6.066.422.001.839.022 1.25.063 2.942-5.778 10.544-9.918 19.479-9.967 7.155-.038 13.482 2.555 17.263 6.539a16.784 16.784 0 0 1 4.607-.63c6.615.01 12.204 3.798 14.04 9Z"
          fill="#ABD6F3"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.328 61.813c-.475-4.773-6.313-8.647-13.528-8.808-6.56-.146-12.113 2.827-13.573 6.937-3.916.252-7.27 2.228-8.984 5.054a9.258 9.258 0 0 0-1.105-.09c-2.681-.06-5.056 1.034-6.4 2.725a2.64 2.64 0 0 0-1.306-.346c-1.338-.006-2.427.95-2.432 2.136-.005 1.185 1.075 2.151 2.412 2.158.073 0 .144-.002.214-.007.434 2.941 3.497 5.269 7.26 5.353a8.802 8.802 0 0 0 3.67-.693 11.83 11.83 0 0 0 4.301 2.157c2.876 2.803 7.895 4.642 13.596 4.61 4.18-.023 7.982-1.048 10.835-2.71 1.153 1.576 3.113 2.608 5.331 2.596 3.527-.02 6.372-2.671 6.354-5.922v-.087l.146.004c3.757.083 6.837-1.54 6.88-3.625.03-1.405-1.325-2.66-3.36-3.357.047-.251.073-.507.078-.766.082-3.881-4.557-7.138-10.389-7.319Z"
        fill="#ABD6F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M298.188 123.815c9.163-.05 17.206-4.188 21.854-10.415 1.31.523 2.763.811 4.292.803 4.393-.024 8.137-2.483 9.637-5.937.3.099.618.152.946.15 1.871-.01 3.378-1.783 3.366-3.959-.012-2.176-1.538-3.932-3.409-3.922a2.964 2.964 0 0 0-1.256.287c-1.698-3.096-5.268-5.218-9.385-5.196-.233.001-.463.01-.692.024-2.77-10.057-13.199-17.5-25.601-17.432-10.089.055-18.819 5.066-23.156 12.364-1.507-1.26-3.31-1.988-5.243-1.977-5.239.028-9.456 5.47-9.42 12.154.037 6.684 4.313 12.08 9.551 12.051 1.779-.009 3.44-.643 4.857-1.738 4.282 7.595 13.28 12.799 23.659 12.743Z"
        fill="#DFF0FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151.637 119.909c8.096.029 14.644 4.498 14.636 9.997-.009 5.509-6.596 9.966-14.713 9.954a21.562 21.562 0 0 1-3.087-.225c-.869 4.442-5.751 7.861-11.662 7.893-3.985.022-7.519-1.501-9.679-3.854-3.732 4.054-10.054 6.739-17.239 6.778-8.672.047-16.13-3.773-19.309-9.25-2.082 1.587-4.734 2.536-7.62 2.532-5.562-.008-10.243-3.554-11.652-8.378-3.47-.383-6.194-2.895-6.308-6.037-.128-3.507 3.042-6.47 7.08-6.617a8.178 8.178 0 0 1 3.455.614c2.057-1.515 4.647-2.416 7.46-2.411.434 0 .864.022 1.287.065 2.035-3.614 6.07-6.072 10.712-6.065.422 0 .839.021 1.25.061 2.942-5.777 10.544-9.917 19.479-9.966 7.155-.038 13.482 2.555 17.263 6.539a16.727 16.727 0 0 1 4.607-.63c6.615.009 12.204 3.798 14.04 9Z"
        fill="#E6F4FF"
      />
    </g>
    <defs>
      <filter
        id="c"
        x="167"
        y="105"
        width="18"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="d"
        x="220.491"
        y="99.615"
        width="17.592"
        height="14.512"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="e"
        x="301"
        y="13"
        width="103.272"
        height="47.452"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation=".5" result="effect1_foregroundBlur" />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h413v183H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" transform="translate(112 35)" d="M0 0h199v172H0z" />
      </clipPath>
    </defs>
  </svg>
);
